<template>
  <div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <Box theme="box-primary" title="Tìm kiếm">
<!--        <div slot="custombtn">-->
<!--          <button id="popover-config-search" class="btn btn-box-tool">-->
<!--            <i class="fa fa-cog" aria-hidden="true"></i>-->
<!--          </button>-->
<!--          <b-popover :show.sync="showConfigSearch" target="popover-config-search" title="Cấu hình hiển thị"-->
<!--                     triggers="hover">-->
<!--            <b-table :items="configSearchItems" responsive :fields="configFields">-->
<!--              <template v-slot:cell(key)="data">-->
<!--                <b-form-checkbox v-model="data.item.show"-->
<!--                                 @change="toggleColumnSearchForm($event, data.item.key)"></b-form-checkbox>-->
<!--              </template>-->
<!--              <template v-slot:cell(label)="data">-->
<!--                {{ data.item.label }}-->
<!--              </template>-->
<!--            </b-table>-->
<!--          </b-popover>-->
<!--        </div>-->
        <div slot="content">
          <div v-show="isShowSearch('created_at')" class="form-group col-md-3 col-sm-6 col-xs-12">
            <label>Thời gian thực hiện</label>
            <date-picker v-model="filterData.created_at" type="datetime" range valueType="format" @change="onCreatedAtChanged"></date-picker>
          </div>
          <div v-show="isShowSearch('phone_number')" class="form-group col-md-3 col-sm-6 col-xs-12">
            <label>Số thành viên</label>
            <input type="text" class="form-control" v-model="filterData.phone_number" v-on:keyup.enter="search"
                   placeholder="Nhập tên số thành viên..."/>
          </div>
          <div v-show="isShowSearch('pics')" class="form-group col-md-3 col-sm-6 col-xs-12">
            <label>Nhân viên kĩ thuật</label>
            <multiselect v-model="filterData.pics" id="ajax1" label="name" track-by="code"
                         placeholder="Nhập để tìm kiếm người dùng"
                         open-direction="bottom" :options="groupUser" :multiple="true" :searchable="true"
                         group-label="label" group-values="users" :group-select="true"
                         select-group-label="Chọn tất cả" deselect-group-label="Bỏ chọn tất cả"
                         :loading="loadingUser" :internal-search="true" :clear-on-select="true"
                         :close-on-select="false" :options-limit="300" :limit="numberOfUser" :max-height="600"
                         :show-no-results="false" :hide-selected="false">
            </multiselect>
          </div>
        </div>
        <div slot="footer">
          <b-button variant="success" @click="search" style="margin-top: 25px">
            <span class="glyphicon glyphicon-search" aria-hidden="true"></span>Tìm kiếm
          </b-button>
        </div>
      </Box>
    </div>

    <div class="col-md-12 col-sm-12 col-xs-12">
      <Box theme="box-primary" title="Danh sách số điện thoại">
        <div slot="custombtn">
          <button id="checked-popover-config-table" class="btn btn-box-tool">
            <i class="fa fa-cog" aria-hidden="true"></i>
          </button>
          <b-popover :show.sync="showCheckedConfigTable" target="checked-popover-config-table" title="Cấu hình hiển thị"
                     triggers="hover">
            <b-table :items="configItems" responsive :fields="configFields">
              <template v-slot:cell(key)="data">
                <b-form-checkbox v-model="data.item.show"
                                 @change="toggleColumn($event, data.item.key)"></b-form-checkbox>
              </template>
              <template v-slot:cell(label)="data">
                {{ data.item.label }}
              </template>
            </b-table>
          </b-popover>
        </div>
        <div slot="content">
          <b-table bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty
                   :select-mode="'multi'"
                   ref="selectableTable"
                   @row-dblclicked="onDoubleClicked"
                   selectable
                   @row-selected="onRowSelected"
          >

            <template #table-busy>
              <div class="text-center my-2 mt-5 mb-5">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Đang tải...</strong>
              </div>
            </template>

            <template #empty="scope">
              <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
            </template>

            <template v-slot:cell(old_phone_number_status)="data">
              <ColorTags v-if="data.item.old_phone_number_status_id"
                         :tags="generateTag(buildStatus(data.item.old_phone_number_status_id))"
                         :size="'md'"></ColorTags>
            </template>
            <template v-slot:cell(phone_number_status)="data">
              <ColorTags v-if="data.item.phone_number_status_id"
                         :tags="generateTag(buildStatus(data.item.phone_number_status_id))" :size="'md'"></ColorTags>
            </template>
            <template v-slot:cell(lock_date)="data">
              <li v-for="(lock, index) in generateLockDate(data.item)" :key="index">{{ lock.provider }}:
                {{ lock.date | format_date }}
              </li>
            </template>
            <template v-slot:cell(unlock_date)="data">
              <li v-for="(lock, index) in generateUnLockDate(data.item)" :key="index">{{ lock.provider }}:
                {{ lock.date | format_date }}
              </li>
            </template>
            <template v-slot:cell(created_at)="data">
              <span>{{ data.item.created_at | format_date_time }}</span>
            </template>
          </b-table>
        </div>
        <div slot="footer">
          <div><strong>Tổng: </strong><label>{{ totalRow }}</label></div>
          <div class="d-flex align-items-center justify-content-between">
            <div class="page-size-container">
              <span>Hiển thị</span>
              <b-form-select
                id="pageSize"
                v-model="pageSize"
                :options="pageSizes"
                required
              ></b-form-select>
              <span>  dòng</span>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRow"
              :per-page="pageSize"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </div>
      </Box>
    </div>

    <b-modal size='xl' id="phoneNumberDetail" hide-footer title="Thông tin số" @hide="() => this.filter()"
             header-class="crm-modal">
      <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
        <CheckedPhoneNumberDetail :id="selectedId" :activity-id="activityId" :hide-modal="hideModal"
                                  :move-status-list="moveStatusList"
                                  :is-technical-staff="isTechnicalStaff"></CheckedPhoneNumberDetail>
      </div>
    </b-modal>

  </div>
</template>

<script>
import Box from '../../../components/Box.vue'
import {
  FEE_TYPE_LIST,
  LOCAL_STORAGE_KEY, LOCK_COUNT_TYPE, MAX_SALE_USER_NUMBER,
  NUMBER_OF_LOCKED_LIST,
  PERMISSION_KEY, PROVIDERS, STATUS_PHONE_NUMBER
} from '../../../common/constant'
import DatePicker from 'vue2-datepicker'
import Multiselect from '../../../lib/vue-multiple-select/Multiselect.vue'
import Utils from '../../../common/utils'
import CheckedPhoneNumberDetail from './CheckedPhoneNumberDetail'
import LegalAPI from '../../../api/legalApi'
import MainPhoneNumberAPI from '../../../api/mainPhoneNumber'
import PhoneNumberAPI from '../../../api/phoneNumberApi'
import PhoneNumberClientAPI from '../../../api/phoneNumberClientApi'
import PhoneNumberProviderAPI from '../../../api/providerApi'
import PhoneNumberStatusAPI from '../../../api/phoneNumberStatusApi'
import ColorTags from '../../../components/ColorTags.vue'
import UserApi from '../../../api/user'
import LockSummary from '.././LockSummary.vue'
import {mapGetters} from 'vuex'
import moment from 'moment'

export default {
  name: 'PhoneNumberManagementList',
  components: {
    Box,
    DatePicker,
    Multiselect,
    CheckedPhoneNumberDetail,
    ColorTags,
    LockSummary
  },
  props: {
    triggerFilter: {
      type: Boolean,
      required: false
    },
  },
  data () {
    return {
      filterData: {
        created_at: [moment().subtract(7, 'day').format('yyyy-MM-DD HH:mm:ss'), moment().format('yyyy-MM-DD HH:mm:ss')],
        phone_number: '',
        pics: [],
      },
      usingStatusList: [
        {text: 'Mạng mở', value: 'OPEN'},
        {text: 'Mạng bị khóa', value: 'LOCK'},
        {text: 'Mạng đang sử dụng', value: 'USING'}
      ],
      telcoList: PROVIDERS,
      lock_count_type_list: LOCK_COUNT_TYPE,
      number_of_locked_list: NUMBER_OF_LOCKED_LIST,
      fee_type_list: FEE_TYPE_LIST,
      lockHistories: {},
      showConfigSearch: false,
      configFields: [
        {
          key: 'key',
          label: 'Hiển thị'
        }, {
          key: 'label',
          label: 'Cột'
        }
      ],
      configSearchItems: [
        {
          key: 'created_at',
          label: 'Thời gian thực hiện',
          show: true
        },
        {
          key: 'phone_number',
          label: 'Số thành viên',
          show: true
        },
        {
          key: 'pics',
          label: 'Nhân viên kĩ thuật',
          show: true
        }
      ],
      configItems: [
        {
          key: 'id',
          label: 'STT',
          show: true
        },
        {
          key: 'phone_number',
          label: 'Số điện thoại',
          show: true
        },
        {
          key: 'old_phone_number_status',
          label: 'Trạng thái cũ',
          show: true
        },
        {
          key: 'phone_number_status',
          label: 'Kết quả kiểm tra',
          show: true
        },
        {
          key: 'lock_date',
          label: 'Ngày khóa',
          show: true
        },
        {
          key: 'unlock_date',
          label: 'Ngày mở',
          show: true
        },
        {
          key: 'created_at',
          label: 'Thời gian thực hiện',
          show: true
        },
        {
          key: 'user_name',
          label: 'Nhân viên kĩ thuật',
          show: true
        }
      ],
      originFields: [
        {
          key: 'id',
          label: 'STT',
          show: true
        },
        {
          key: 'phone_number',
          label: 'Số điện thoại',
          show: true
        },
        {
          key: 'old_phone_number_status',
          label: 'Trạng thái cũ',
          show: true
        },
        {
          key: 'phone_number_status',
          label: 'Kết quả kiểm tra',
          show: true
        },
        {
          key: 'lock_date',
          label: 'Ngày khóa',
          show: true
        },
        {
          key: 'unlock_date',
          label: 'Ngày mở',
          show: true
        },
        {
          key: 'user_name',
          label: 'Nhân viên kĩ thuật',
          show: true
        },
        {
          key: 'created_at',
          label: 'Thời gian thực hiện',
          show: true
        }
      ],
      showCheckedConfigTable: false,
      fields: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      sumValue: 0,
      pageSizes: [
        {text: 1000, value: 1000},
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      statusPhoneNumberId: {
        LOCKED: 0,
        MONITORING: 0,
        FALSE_POSITIVE: 0,
        NEW: 0,
        QUALIFIED: 0,
        UNQUALIFIED: 0,
        RETEST: 0,
        UNLOCKED: 0,
        WAIT_CANCEL: 0,
        NOT_USE: 0
      },
      isEditable: true,
      items: [],
      selectedId: null,
      activityId: null,
      selected: [],
      company: null,
      isTechnicalStaff: false,
      providersList: [],
      phoneStatusList: [],
      moveStatusList: [],
      phoneClientsList: [],
      mainPhoneNumberList: [],
      legalList: [],
      bulkUpdateStatusData: null,
      importFile: null,
      isBulkUpdateAll: false,
      users: [],
      groupUser: [],
      loadingUser: false,
      loadFilterDateFromCache: false,
      numberOfUser: 2,
      statistic: {
        age_avg: 0,
        total_init_fee: 0,
        total_operate_fee: 0,
        total_open_fee: 0,
        total_other_fee: 0,
        technical_staff: []
      },
      checkAll: false,
    }
  },
  onResizeScreen () {
    if (window.innerWidth < 1550) {
      this.numberOfUser = 1
    } else {
      this.numberOfUser = 2
    }
  },
  created () {
    this.fields = this.originFields
    window.addEventListener('resize', this.onResizeScreen)
  },
  methods: {
    onRowSelected (items) {
      this.selected = items
    },
    onDoubleClicked (item) {
      this.activityId = item.id
      this.selectedId = item.phone_number_id
      this.detail(item.phone_number_id)
    },
    detail (id) {
      this.$bvModal.show('phoneNumberDetail')
    },
    toggleColumnSearchForm (event, key) {
      this.configSearchItems = this.configSearchItems.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })
      localStorage.setItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_SEARCH_ITEMS, JSON.stringify(this.configSearchItems))
    },
    getFilterRequest () {
      return {
        created_at_from: this.filterData.created_at ? this.filterData.created_at[0] : null,
        created_at_to: this.filterData.created_at ? this.filterData.created_at[1] : null,
        pics: this.filterData.pics.map(item => item.code),
        phone_number: this.filterData.phone_number
      }
    },
    filter () {
      if (this.loading) {
        return
      }
      // this.selectedId = null
      // this.activityId = null
      this.loading = true
      PhoneNumberAPI.filterTechnicalActivity(this.getFilterRequest(), this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    filterUser (query) {
      this.loadingUser = true
      UserApi.findTechnicalStaffByName(query, this.company.id, 0, MAX_SALE_USER_NUMBER).then(res => {
        this.users = res.data.data.records.map(item => {
          return {'name': item.username, 'code': item.id}
        })

        this.users.unshift({
          'name': 'Chưa gán kĩ thuật',
          'code': null
        })

        this.filterData.pics = this.users

        this.groupUser = [
          {
            label: 'Tất cả',
            users: this.users
          }
        ]
        this.loadingUser = false
        this.filter()
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingUser = false
      })
    },
    search () {
      this.filter()
    },
    isShowSearch (key) {
      const item = this.configSearchItems.find(item => item.key === key)
      if (item) {
        return item.show
      }
      return false
    },
    toggleColumn (event, key) {
      this.originFields = this.originFields.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })
      this.fields = this.originFields.filter(item => item.show)

      this.configItems = this.configItems.map(field => {
        if (field.key === key) {
          return {...field, show: event}
        }
        return field
      })
      localStorage.setItem(LOCAL_STORAGE_KEY.CHECKED_PHONE_NUMBER_COLUMN_SHOW, JSON.stringify(this.configItems))
    },
    hideModal (modalId) {
      // this.selectedId = null
      // this.activityId = null
      this.$bvModal.hide(modalId)
    },
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_MANAGER) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_MANAGER)
    },
    async getLegal () {
      const response = await LegalAPI.filter({}, 0, 100)
      return response.data.data.records
    },
    async getMainPhoneNumber () {
      const response = await MainPhoneNumberAPI.filter({}, 0, 100)
      return response.data.data.records
    },
    async getPhoneNumberClient () {
      const response = await PhoneNumberClientAPI.filter({}, 0, 100)
      return response.data.data.records
    },
    async getPhoneNumberStatus () {
      const response = await PhoneNumberStatusAPI.filter({}, 0, 100)
      return response.data.data.records
    },
    async getPhoneNumberProvider () {
      const response = await PhoneNumberProviderAPI.filter({}, 0, 100)
      return response.data.data.records
    },
    async initFilter () {
      return Promise.all([this.getLegal(), this.getMainPhoneNumber(), this.getPhoneNumberClient(),
        this.getPhoneNumberStatus(), this.getPhoneNumberProvider()])
        .then(([legals, mainPhoneNumbers, phoneClients, status, providers]) => {
          this.legalList = legals.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.LEGAL_LIST, JSON.stringify(this.legalList))
          this.mainPhoneNumberList = mainPhoneNumbers.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.MAIN_PHONE_NUMBER_LIST, JSON.stringify(this.mainPhoneNumberList))
          this.phoneClientsList = phoneClients.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_CLIENT, JSON.stringify(this.phoneClientsList))
          this.phoneStatusList = status.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.PHONE_STATUS_LIST, JSON.stringify(this.phoneStatusList))
          this.providersList = providers.map(item => {
            return {value: item.id, text: item.name, color: item.color, choose_by_default: item.choose_by_default}
          })
          localStorage.setItem(LOCAL_STORAGE_KEY.PROVIDER_LIST, JSON.stringify(this.providersList))
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
    },
    buildPhoneClient (value) {
      return this.phoneClientsList.find(item => item.value === value)
    },
    buildStatus (value) {
      return this.phoneStatusList.find(item => item.value === value)
    },
    buildLegal (value) {
      return this.legalList.find(item => item.value === value)
    },
    buildProvider (value) {
      return this.providersList.find(item => item.value === value)
    },
    generateLockDate (item) {
      let lockDate = []
      if (item.viettel_lock_date) {
        lockDate.push({
          provider: 'Viettel',
          date: item.viettel_lock_date
        })
      }
      if (item.mobifone_lock_date) {
        lockDate.push({
          provider: 'Mobifone',
          date: item.mobifone_lock_date
        })
      }
      if (item.vinaphone_lock_date) {
        lockDate.push({
          provider: 'Vinanphone',
          date: item.vinaphone_lock_date
        })
      }
      if (item.other_lock_date) {
        lockDate.push({
          provider: 'Ngoại mạng',
          date: item.other_lock_date
        })
      }
      return lockDate
    },
    generateUnLockDate (item) {
      let lockDate = []
      if (item.viettel_unlock_date) {
        lockDate.push({
          provider: 'Viettel',
          date: item.viettel_unlock_date
        })
      }
      if (item.mobifone_unlock_date) {
        lockDate.push({
          provider: 'Mobifone',
          date: item.mobifone_unlock_date
        })
      }
      if (item.vinaphone_unlock_date) {
        lockDate.push({
          provider: 'Vinanphone',
          date: item.vinaphone_unlock_date
        })
      }
      if (item.other_unlock_date) {
        lockDate.push({
          provider: 'Ngoại mạng',
          date: item.other_unlock_date
        })
      }
      return lockDate
    },
    generateTag (selectedRow) {
      if (selectedRow) {
        const text = selectedRow.text
        const color = selectedRow.color
        return [{text: text, color: color}]
      }
    },
    buildMainPhoneNumber (value) {
      return this.mainPhoneNumberList.find(item => item.value === value)
    },
    getTechnicalStaffName (item) {
      if (item.pic_id) {
        const found = this.users.find(u => u.code === item.pic_id)
        if (found !== undefined) {
          return found.name
        }
      }
      return ''
    },
    onCheckAll (event) {
      if (this.checkAll === 'check_all') {
        this.$refs.selectableTable.selectAllRows()
      } else {
        this.$refs.selectableTable.clearSelected()
      }
    },
    toggleRow (row) {
      if (row.rowSelected) {
        this.$refs.selectableTable.selectRow(row.index)
      } else {
        this.$refs.selectableTable.unselectRow(row.index)
      }
    },
    initStatusId () {
      let id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.LOCKED)
      if (id !== undefined) {
        this.statusPhoneNumberId.LOCKED = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.MONITORING)
      if (id !== undefined) {
        this.statusPhoneNumberId.MONITORING = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.FALSE_POSITIVE)
      if (id !== undefined) {
        this.statusPhoneNumberId.FALSE_POSITIVE = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.NEW)
      if (id !== undefined) {
        this.statusPhoneNumberId.NEW = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.QUALIFIED)
      if (id !== undefined) {
        this.statusPhoneNumberId.QUALIFIED = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.UNQUALIFIED)
      if (id !== undefined) {
        this.statusPhoneNumberId.UNQUALIFIED = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.RETEST)
      if (id !== undefined) {
        this.statusPhoneNumberId.RETEST = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.UNLOCKED)
      if (id !== undefined) {
        this.statusPhoneNumberId.UNLOCKED = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.WAIT_CANCEL)
      if (id !== undefined) {
        this.statusPhoneNumberId.WAIT_CANCEL = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.NOT_USE)
      if (id !== undefined) {
        this.statusPhoneNumberId.NOT_USE = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.CONFIRM_CANCEL)
      if (id !== undefined) {
        this.statusPhoneNumberId.CONFIRM_CANCEL = id.value
      }

      id = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.CONFIRM_NOT_USE)
      if (id !== undefined) {
        this.statusPhoneNumberId.CONFIRM_NOT_USE = id.value
      }

      let allowStatusList = [this.statusPhoneNumberId.MONITORING, this.statusPhoneNumberId.NEW, this.statusPhoneNumberId.RETEST, this.statusPhoneNumberId.WAIT_CANCEL, this.statusPhoneNumberId.NOT_USE]
      if (this.isTechnicalStaff) {
        this.moveStatusList = this.moveStatusList.filter(item => allowStatusList.indexOf(item.value) > -1)
      }
    },
    onCreatedAtChanged () {

    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  async mounted () {
    // this.isEditable = this.hasEditPermission()
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    this.isTechnicalStaff = Utils.isTechnicalStaff(this.userInfo)
    await this.initFilter()
    this.initStatusId()
    this.filterUser('')
    const phoneNumberSearchItems = localStorage.getItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_SEARCH_ITEMS)
    if (phoneNumberSearchItems) {
      this.configSearchItems = JSON.parse(phoneNumberSearchItems)
    }
    const columnShow = localStorage.getItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_COLUMN_SHOW)
    if (columnShow) {
      this.configItems = JSON.parse(columnShow)

      this.originFields = this.originFields.map(field => {
        let config = this.configItems.find(item => item.key === field.key)
        if (config) {
          return {...field, show: config.show}
        }
        return field
      })
      this.fields = this.originFields.filter(item => item.show)
    }
    this.filter()
  },
  watch: {
    triggerFilter: {
      handler: function () {
        this.filter()
      }
    },
    currentPage: {
      handler: function () {
        this.filterData.created_at = [moment().subtract(7, 'day').format('yyyy-MM-DD HH:mm:ss'), moment().format('yyyy-MM-DD HH:mm:ss')]
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/phone_number_management/techical_list/PhoneNumberCheckedList.vue